import React, { useMemo } from 'react';
// eslint-disable-next-line no-restricted-imports -- TODO: legacy connect (baseline)
import { connect } from 'react-redux';

import { selector as linksSelector } from '../../../../../redux/modules/secondary-nav';
import { injectRoleManagement } from '../../../../../utils/permissions/role-utils';
import FormattedMessage from 'components/formatted-message';

import { GearLauncherIcon } from './launcher-icons';
import { POPOVER_ID } from './launcher-config';
import { useHeaderPins } from './hooks/use-header-pins';
import { useLauncherLinks } from './hooks/use-launcher-links';
import { useLauncherPopover } from './hooks/use-launcher-popover';
import { useShallowStable } from './hooks/use-shallow-stable';
import { LauncherDots } from './components/launcher-dots';
import { LauncherGrid } from './components/launcher-grid';
import { LauncherOverflow } from './components/launcher-overflow';
import { LauncherCustomizeList } from './components/launcher-customize-list';
import styles from './app-launcher.module.css';

const EMPTY_LINKS = [];

const AppLauncher = ({ links = EMPTY_LINKS, shiftsOnly, goalieOnly, ...restRoleProps }) => {
    const role = useMemo(() => ({ shiftsOnly, goalieOnly }), [shiftsOnly, goalieOnly]);
    // The rest object is new on every render; keep it stable so visibleLinks/activePins stay memoized.
    const roleProps = useShallowStable(restRoleProps);
    const isLimitedAccount = shiftsOnly || goalieOnly;

    const { opened, customizeOpen, rootRef, close, toggleOpen, toggleCustomize } = useLauncherPopover();
    const { visibleLinks, gridItems } = useLauncherLinks({ links, role, roleProps, isLimitedAccount });
    const { activePins, toggleHeaderPin } = useHeaderPins({ visibleLinks, role });

    if (!visibleLinks.length) {
        return null;
    }

    return (
        <div className={styles.root} ref={rootRef}>
            <button
                className={styles.button}
                type="button"
                aria-label="Launcher"
                aria-expanded={opened}
                aria-controls={POPOVER_ID}
                onClick={toggleOpen}
            >
                <LauncherDots />
            </button>
            {!!opened && (
                <div className={styles.popover} id={POPOVER_ID} role="dialog" aria-label="Launcher">
                    {!!gridItems.length && <LauncherGrid items={gridItems} onNavigate={close} />}
                    {gridItems.length === 0 && !customizeOpen && (
                        <LauncherOverflow links={visibleLinks} onNavigate={close} />
                    )}
                    <button
                        className={styles.customizeRow}
                        type="button"
                        onClick={toggleCustomize}
                        aria-expanded={customizeOpen}
                    >
                        <FormattedMessage id="launcher.customize" />
                        <GearLauncherIcon />
                    </button>
                    {!!customizeOpen && (
                        <LauncherCustomizeList
                            links={visibleLinks}
                            activePins={activePins}
                            onTogglePin={toggleHeaderPin}
                        />
                    )}
                </div>
            )}
        </div>
    );
};

export default connect(state => ({ links: linksSelector(state) }))(injectRoleManagement(AppLauncher));
